// extracted by mini-css-extract-plugin
export default {"new_user":"NewUser_new_user__zAcKn","form_new":"NewUser_form_new__VIwBw","buttons":"NewUser_buttons__bdnV5"};